import styled from 'styled-components';
import { Box } from '@rsos/base-components';

const MAIN_MAX_HEIGHT = '300px';
const PREVIEW_MAX_HEIGHT = '80px';
const FULLSCREEN_MAIN_MAX_HEIGHT = '600px';
const FULLSCREEN_PREVIEW_MAX_HEIGHT = '160px';

export const CarouselContainer = styled(Box).attrs({
  bg: 'background',
  justify: 'center',
})`
  ${({ isFullscreen }) => isFullscreen && 'padding: 16px;'};
  width: 100%;
`;

export const CurrentCarouselContainer = styled(Box)`
  width: 100%;
`;
export const CarouselPreviewContainer = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: ${({ showArrows }) =>
    showArrows ? '16px 1fr 16px' : '1fr'};
  height: 100%;
  padding-top: 16px;
  width: 100%;
`;

export const toBlurOrNotToBlur = isBlurred => {
  if (isBlurred) {
    return `
        filter: blur(8px);
        -webkit-filter: blur(8px);
      `;
  }
};

export const MainImg = styled.img`
  ${({ isBlurred }) => {
    return toBlurOrNotToBlur(isBlurred);
  }};

  max-height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_MAIN_MAX_HEIGHT : MAIN_MAX_HEIGHT};
  object-fit: contain;
  pointer-events: none;
  width: 100%;
`;

export const MainVideo = styled.video`
  ${({ isBlurred }) => {
    return toBlurOrNotToBlur(isBlurred);
  }};

  max-height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_MAIN_MAX_HEIGHT : MAIN_MAX_HEIGHT};
  object-fit: contain;
  pointer-events: none;
  width: 100%;
`;

export const MainContainer = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  width: '100%',
})`
  height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_MAIN_MAX_HEIGHT : MAIN_MAX_HEIGHT};
  position: relative;
`;
export const MediaContainer = styled(Box).attrs({
  align: 'center',
  alignSelf: 'center',
  height: '100%',
  justify: 'center',
  overflow: 'hidden', // prevents the blur from bleeding
  width: '100%',
})``;

export const PreviewContainer = styled(Box).attrs({
  align: 'center',
  borderStyle: 'solid',
  borderWidth: '3px',
  justify: 'center',
  mx: '5px',
  overflow: 'hidden', // prevents the blur from bleeding
  width: '100%',
})`
  border-color: ${({ highlight, theme }) =>
    highlight ? `${theme.colors.primaryBase}` : 'transparent'};
  cursor: pointer;
  position: relative;
`;

export const PreviewImg = styled.img`
  ${({ isBlurred }) => {
    return toBlurOrNotToBlur(isBlurred);
  }};
  height: 100%;
  max-height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_PREVIEW_MAX_HEIGHT : PREVIEW_MAX_HEIGHT};
  max-width: 60px;
  object-fit: cover;
  pointer-events: none;
  width: 100%;
`;

export const PreviewVideo = styled.video`
  ${({ isBlurred }) => {
    return toBlurOrNotToBlur(isBlurred);
  }};
  max-height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_PREVIEW_MAX_HEIGHT : PREVIEW_MAX_HEIGHT};
  pointer-events: none;
`;

export const ArrowBase = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  width: '24px',
})`
  height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_PREVIEW_MAX_HEIGHT : PREVIEW_MAX_HEIGHT};
  &:hover {
    cursor: pointer;
  }
`;

export const LeftArrow = styled(ArrowBase)``;
export const RightArrow = styled(ArrowBase)``;

export const IconWrapper = styled(Box).attrs({
  borderRadius: '5px',
  color: '#fff',
  padding: '5px',
})`
  background: rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;

export const ErrorContainer = styled(Box).attrs({
  align: 'center',
  bg: 'foreground',
  justify: 'center',
  position: 'relative',
})`
  height: ${({ isFullscreen }) =>
    isFullscreen ? FULLSCREEN_MAIN_MAX_HEIGHT : MAIN_MAX_HEIGHT};
`;
